<template>
  <q-card
    class="relative bg-white flex flex-col size-full p-4 shadow-sm rounded-xl border border-neutral-100/10 hover:border-primary-admin/30 overflow-hidden"
  >
    <div class="absolute top-0 left-0 w-full">
      <img
        :src="useAssets('/static/images/orn_card.png')"
        alt="ornamento"
        class="size-full"
      />
    </div>

    <div
      class="w-full h-[12rem] grid place-items-center p-32 shrink-0"
    >
      <img
        :src="
          assessment.logo_png || useAssets('/static/images/orbit.png')
        "
        :alt="assessment.nome_fantasia"
        class="w-full h-[7.5rem] object-contain"
      />
    </div>

    <div
      class="relative flex-1 bg-white flex flex-col gap-16 border border-neutral-100/10 rounded-lg p-20"
    >
      <OrnOrbit class="absolute left-0 top-20" />
      <h3 class="text-headline-1 text-neutral-100 flex-1">
        {{ assessment.nome_fantasia || assessment.nome }}
      </h3>
      <OButton
        primary
        size="md"
        :label="t('access')"
        :href="`/${assessment.slug}/acompanhamentos`"
        class="w-full !bg-primary-admin text-headline-3 text-primary-admin-10"
      />
    </div>
  </q-card>
</template>

<script setup>
import { useAssets } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import OButton from 'components/Button/OButton.vue'
import OrnOrbit from 'public/icons/orn_card_title.svg'

const { t } = useI18n()

const props = defineProps({
  assessment: Object,
})
</script>

<style lang="scss" scoped></style>
